import { render, staticRenderFns } from "./NotificationPessoa.vue?vue&type=template&id=40ec4f80&scoped=true"
import script from "./NotificationPessoa.vue?vue&type=script&lang=js"
export * from "./NotificationPessoa.vue?vue&type=script&lang=js"
import style0 from "./NotificationPessoa.vue?vue&type=style&index=0&id=40ec4f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ec4f80",
  null
  
)

export default component.exports